import { useCallback, useEffect, useState } from "react";
import { clientApiService, ClientDashboard } from "../services/client-api.service";

export function useDashboard() {
  const [data, setData] = useState<ClientDashboard | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await clientApiService.getDashboard();
      setData(result);
    } catch (err: any) {
      setError(err?.message || "Error al cargar dashboard");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { data, isLoading, error, refresh: load };
}